import CustomButton from "components/common/Button/CustomButton";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import { apiDeleteRequest } from "helpers/Requests";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { getParticipantCall } from "store/actions/participant.actions";
import { getUrlRole, selectedTabState } from "Utils/utils";

const BulkDeleteFormModal = (props) => {
  const {
    open,
    setOpen,
    selectedForms,
    role,
    refreshFormList,
    parentSlug,
  } = props;

  const dispatch = useDispatch();
  const { uuid: participantUUID } = useParams();

  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });

  const handleBulkDelete = async () => {
    setRequest({ isRequested: true, isSuccess: false, isFailed: false });

    try {
      let deletePromises = [];

      for (const uuid of selectedForms) {
        let url = "";

        if (role === "sil") {
          url = `/sil/home/form/delete-form/${uuid}`;
        } else if (parentSlug === "worker-profile" || role === "hrm") {
          url = `/${getUrlRole()}/employee/delete-form/${uuid}`;
        } else {
          url = `/${getUrlRole()}/participant/delete-form/${uuid}`;
        }

        deletePromises.push(apiDeleteRequest(url, { form_uuid: uuid }));
      }

      const responses = await Promise.all(deletePromises);
      const successCount = responses.filter(
        (res) => res.status === 200
      ).length;

      if (successCount === selectedForms.length) {
        toast.success(
          `${successCount} form${successCount > 1 ? "s" : ""} deleted successfully!`
        );
        setOpen(false);
        refreshFormList();

        // Preserve the Forms tab (id: 4) after deletion
        if (participantUUID) {
          const currentTab = selectedTabState.get();
          if (currentTab && currentTab.id === 4) {
            selectedTabState.save(JSON.stringify(currentTab));
          } else {
            selectedTabState.save(JSON.stringify({ name: "Forms", id: 4, children: [] }));
          }
          dispatch(getParticipantCall({ participantUUID: participantUUID }));
        }
      } else {
        throw new Error(
          `Failed to delete ${selectedForms.length - successCount} form(s)`
        );
      }
    } catch (error) {
      setRequest({ isRequested: false, isSuccess: false, isFailed: true });
      console.error("Failed to delete forms:", error);
      toast.error("Failed to delete some forms. Please try again.");
    } finally {
      setRequest({ isRequested: false, isSuccess: false, isFailed: false });
    }
  };

  const modalFooter = () => (
    <>
      <CustomButton
        showLoading={request.isRequested}
        isDisabled={request.isRequested}
        label={`Yes, delete ${selectedForms.length} form${selectedForms.length > 1 ? "s" : ""}`}
        clickHandler={handleBulkDelete}
        variant='danger'
      />
      <CustomButton label='No, cancel' onClick={() => setOpen(false)} />
    </>
  );

  return (
    <>
      <ModalSkeleton
        modalFooter={modalFooter()}
        isOpen={open}
        closeModal={() => setOpen(false)}
        cssClass='w-[35%]'
        title={"Delete Forms"}
      >
        <div>
          <p className='text-gray-700'>
            Are you sure you want to delete {selectedForms.length} selected
            form{selectedForms.length > 1 ? "s" : ""}? This action cannot be
            undone.
          </p>
          <p className="text-xs text-gray-500 mt-2">This action will be recorded in the audit log.</p>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default BulkDeleteFormModal;
